// styles.js
export const textFieldStyles = {
    '& .MuiInputBase-input': {
        color: '#2c3e50',
    },
    '& .MuiInputLabel-root': {
        color: '#6c757d',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#dcdcdc',
        },
        '&:hover fieldset': {
            borderColor: '#2c3e50',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#42a5f5',
        },
    },
};

export const formControlStyles = {
    '& .MuiInputLabel-root': {
        color: '#6c757d', // Label color
        backgroundColor: '#ffffff', // White background to overlay on the border
        padding: '0 4px', // Add padding to the label for spacing
        marginLeft: '-4px', // Adjust left margin for proper alignment
    },
    '& .MuiSelect-select': {
        color: '#2c3e50', // Selected text color
    },
    '& .MuiSelect-root': {
        color: '#2c3e50', // Selected text color
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#dcdcdc', // Default border color
        },
        '&:hover fieldset': {
            borderColor: '#2c3e50', // Hover border color
        },
        '&.Mui-focused fieldset': {
            borderColor: '#42a5f5', // Focused border color
        },
    },
};